import React from "react";
import { Form, Input } from "antd";
import _ from "lodash";
import { nicknameRegex, validate } from "../../../utils/validations";

const Ns1Form = ({ wizardState, setWizardState, setSubmitDisabled }) => {
  const [form] = Form.useForm();
  const layout = {};

  const checkValidation = (formValues) => {
    let formValid = true;
    const { name, token } = formValues;

    if (_.isEmpty(name) || _.isEmpty(token)) {
      formValid = false;
    }

    if (!_.isEmpty(name) && !validate(nicknameRegex.regex, name)) {
      formValid = false;
    }
    return setSubmitDisabled(!formValid);
  };

  return (
    <div className="NS1Form col">
      <div className="NS1Form__intro col">
        <span className="dark-blue bold">
          Procedure
        </span>
        <ol className="NS1Form__intro-orderedlist">
          <li key="1">
            Log in to your NS1 account.
          </li>
          <li key="2">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://help.ns1.com/hc/en-us/articles/360017341694-Managing-API-keys#idm45892557001984"
            >
              Create an API Key
            </a>.
          </li>
          <li key="3">
            Enter a descriptive name in the <span className="bold">Nickname</span> field.
          </li>
          <li key="4">
            Copy and paste the API key into the <span className="bold">API Key</span> field.
          </li>
          <li key="5">
            Select <span className="bold">Next</span>.
          </li>
        </ol>
      </div>

      <Form
        {...layout}
        name="ns1-wizard-form"
        form={form}
        initialValues={{
          name: wizardState.name || "NS1 Integration",
        }}
        className="AppWizard__content-body-form"
        onValuesChange={(
          changedValues,
          allValues // this is how you can get the form values
        ) => {
          setWizardState(Object.assign(wizardState, allValues));
          checkValidation(allValues);
        }}
      >
        <Form.Item
          label="Nickname"
          name="name"
          rules={[
            {
              required: true,
              message: "Nickname is required",
            },
            {
              pattern: nicknameRegex.regex,
              message: nicknameRegex.msg,
            },
          ]}
          style={{ marginBottom: "1.5rem", flexDirection: "column" }}
        >
          <Input placeholder="" />
        </Form.Item>

        <Form.Item
          label="API Key"
          name="token"
          rules={[
            {
              required: true,
              message: "API Key is required",
            },
          ]}
          style={{ marginBottom: "1.5rem", flexDirection: "column" }}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </div>
  );
};

export default Ns1Form;
